export default "__VITE_ASSET__28fb6ca7__"